<mat-list-item>
  <span matListItemTitle class="igo-list-item-with-text-overflow-ellipsis">
    {{ title }}
  </span>
  <div matListItemMeta>
    @if (catalog().externalProvider) {
      <mat-icon
        matListItemIcon
        class="igo-external-provider"
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.catalog.externalProvider.catalog' | translate"
        color="primary"
        (click)="$event.stopPropagation()"
      >
        public
      </mat-icon>
    }
    @if (catalog().removable) {
      <button
        mat-icon-button
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.catalog.library.remove' | translate"
        color="warn"
        (click)="removeCatalogFromLibrary($event)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }

    @if (!catalog().removable) {
      <button class="igo-blank" disabled="true" mat-icon-button>
        <mat-icon />
      </button>
    }
  </div>
</mat-list-item>
